var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05462 1.88973H11.1648V0.112175H0.499512V14.3326H4.05462V1.88973Z",
    fill: "#848484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5008 17.8878H5.83545V3.66741H16.5008V17.8878Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/Copyicon.2ea32de355fdcc5b29c4a5df4a1ffb65.svg";
export { ForwardRef as ReactComponent };